import { Link } from "react-router-dom";
import { Camera, ArrowRight } from "lucide-react";
import { Reveal } from "../components/Reveal";
import { ProjectCard } from "../components/ProjectCard";
import { PORTFOLIO_GROUPS } from "../lib/content";

export default function Portofoliu() {
  const scrollTo = (id) => (e) => {
    e.preventDefault();
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <main data-testid="portofoliu-page">
      <section className="grain-overlay wood-ring bg-anthracite pb-20 pt-36 text-cream lg:pb-28 lg:pt-44">
        <div className="relative z-[2] mx-auto max-w-7xl px-5 sm:px-8">
          <Reveal>
            <p className="font-mono text-xs uppercase tracking-[0.35em] text-oak">Galerie foto / portofoliu</p>
            <h1 className="mt-5 max-w-3xl font-serif text-4xl font-black leading-[1.08] tracking-tight sm:text-5xl lg:text-6xl">
              Lucrări reale, <em className="italic text-oak">de la montaj</em>
            </h1>
            <p className="mt-6 flex max-w-2xl items-start gap-3 text-base leading-relaxed text-cream/70 sm:text-lg">
              <Camera size={20} className="mt-1 shrink-0 text-oak" />
              Primele fotografii reale de la montaj sunt deja aici, iar restul spațiilor
              așteaptă pozele proiectelor următoare, direct din atelierul nostru.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-5 py-16 sm:px-8 lg:py-24">
        <Reveal>
          <nav
            data-testid="portfolio-group-nav"
            aria-label="Categorii portofoliu"
            className="flex flex-wrap gap-3 rounded-sm border border-line bg-sand p-3"
          >
            {PORTFOLIO_GROUPS.map((g) => (
              <a
                key={g.id}
                href={`#${g.id}`}
                onClick={scrollTo(g.id)}
                data-testid={`group-nav-${g.id}`}
                className="rounded-full border border-line bg-white px-5 py-2 font-mono text-[11px] uppercase tracking-[0.2em] text-clay transition-colors duration-300 hover:border-oak hover:text-walnut"
              >
                {g.title}
              </a>
            ))}
          </nav>
        </Reveal>

        {PORTFOLIO_GROUPS.map((g, gi) => (
          <div key={g.id} id={g.id} data-testid={`portfolio-section-${g.id}`} className="scroll-mt-32 pt-16 lg:pt-20">
            <Reveal>
              <div className="flex flex-col justify-between gap-3 border-b border-line pb-6 sm:flex-row sm:items-end">
                <div>
                  <span className="font-serif text-4xl font-black text-oak/35">
                    {String(gi + 1).padStart(2, "0")}
                  </span>
                  <h2 className="mt-2 font-serif text-2xl font-bold tracking-tight text-ink sm:text-3xl">
                    {g.title}
                  </h2>
                  <p className="mt-2 max-w-xl text-sm leading-relaxed text-clay">{g.description}</p>
                </div>
                <span className="shrink-0 font-mono text-[10px] uppercase tracking-[0.25em] text-walnut">
                  {g.items.filter((i) => i.photos.length > 0).length} proiecte reale
                </span>
              </div>
            </Reveal>
            <div className="mt-8 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
              {g.items.map((item, i) => (
                <Reveal key={item.title} delay={i * 0.06}>
                  <ProjectCard
                    index={i + 1}
                    category={g.title}
                    title={item.title}
                    photos={item.photos}
                    beforeAfter={item.beforeAfter}
                  />
                </Reveal>
              ))}
            </div>
          </div>
        ))}

        <Reveal className="mt-16 text-center">
          <p className="mx-auto max-w-xl text-sm leading-relaxed text-clay">
            Vrei să vezi mai multe sau ai un proiect asemănător? Sună-ne sau trimite-ne
            ideea ta și îți arătăm lucrări relevante pentru spațiul tău.
          </p>
          <Link
            to="/contact"
            data-testid="portfolio-contact-link"
            className="group mt-7 inline-flex h-12 items-center gap-3 rounded-full bg-anthracite px-7 text-xs font-bold uppercase tracking-[0.15em] text-cream transition-all duration-300 hover:-translate-y-0.5 hover:bg-walnut"
          >
            Discută proiectul tău
            <ArrowRight size={15} className="transition-transform duration-300 group-hover:translate-x-1.5" />
          </Link>
        </Reveal>
      </section>
    </main>
  );
}
